import React from 'react';
import { Modal } from 'react-bootstrap';
import styles from './style.module.scss';

interface Props {
  data: any[];
  show: boolean;
  onCancel: () => void;
  onSend: () => void;
  onClose: () => void;
}

const BulkTokenTransferModal: React.FC<Props> = ({
  data,
  show,
  onCancel,
  onClose,
  onSend,
}) => {
  // Debug: Log the data to see its structure
  console.log('BulkTokenTransferModal data:', data);

  return (
    <Modal
      show={show}
      onHide={onCancel}
      centered
      dialogClassName={styles.multiple_dialog_content}
    >
      <Modal.Header closeButton>
        <Modal.Title>Bulk Token Transfer</Modal.Title>
      </Modal.Header>

      <p className={styles.previewDescription}>
        Your file has been uploaded successfully. A summary of the records is
        shown below :
      </p>

      <Modal.Body className={styles.multiple_previewModal}>
        <div className={styles.scrollTable}>
          <table className={styles.previewTable}>
            <thead>
              <tr>
                <th>Email</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              {data.slice(0, 5).map((row, i) => (
                <tr key={i}>
                  <td>{row.Email}</td>
                  <td>{row.Amount}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {data.length > 5 && (
          <div className={styles.moreCount}>+{data.length - 5} more</div>
        )}
      </Modal.Body>

      <Modal.Footer className={styles.multiple_modalActions}>
        <div className={styles.buttonWrapper}>
          <button className={styles.cancelBtn} onClick={onCancel}>
            Cancel
          </button>
          <button
            className={styles.addBtn}
            onClick={() => {
              onSend();
              onClose();
            }}
          >
            Send Tokens
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default BulkTokenTransferModal;
